module.exports = __webpack_public_path__ + "img/card-teenpatti.2470b71.jpg";